import React, { Component, Fragment } from 'react'
import FontAwesome from 'react-fontawesome'
import {
	StyledAddress,
	StyledUndo
} from '../address-manager/styles/address.style'

class Address extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isRemoving: false,
			isFading: false,
			timeOutToRemove: null
		}
	}

	handleRemove = () => {
		this.setState({
			isRemoving: true,
			timeOutToRemove: setTimeout(() => {
				this.remove()
			}, 2000)
		})
	}

	undoRemoving = () => {
		this.setState({
			isRemoving: false,
			isFading: false,
			timeOutToRemove: clearTimeout(this.state.timeOutToRemove)
		})
	}

	remove = () => {
		this.setState({ isFading: true }, () => {
			setTimeout(() => {
				this.props.onRemove()
				this.setState({ isRemoving: false, isFading: false })
			}, 150)
		})
	}

	render() {
		const { address, onSelect, onEdit } = this.props
		const { isRemoving, isFading } = this.state

		return (
			<StyledAddress
				isActive={address.shippingAddress}
				className={`animated ${isFading ? 'fadeIn' : ''}`}>
				{isRemoving ? (
					<StyledUndo className="undo bold" onClick={this.undoRemoving}>
						Desfazer
					</StyledUndo>
				) : (
					<Fragment>
						{isIncompleteAddress(address) ? (
							<IncompleteAddress onClick={onSelect} {...address} />
						) : (
							<CompleteAddress onClick={onSelect} {...address} />
						)}
						<div className="controls">
							<FontAwesome
								name="pencil"
								onClick={onEdit}
								title="Editar endereço"
							/>
							{address.shippingAddress ||
							address.billingAddress ? null : (
								<FontAwesome
									name="trash"
									onClick={this.handleRemove}
									title="Excluir endereço"
								/>
							)}
						</div>
					</Fragment>
				)}
			</StyledAddress>
		)
	}
}

const isIncompleteAddress = ({ street, number, neighborhood, zipCode }) =>
	[street, number, neighborhood, zipCode].some(value => value === null)

const CompleteAddress = ({
	onClick,
	street,
	number,
	complement,
	neighborhood,
	city,
	state,
	zipCode
}) => (
	<div
		className="address"
		title="Escolher como endereço de cobrança"
		onClick={onClick}>
		<span className="bold">{street}</span> <br />
		N° {number} {complement} <br />
		{neighborhood} <br />
		{city} - {state} <br />
		CEP {zipCode} <br />
	</div>
)

const IncompleteAddress = ({ onClick, city, state }) => (
	<div
		className="address"
		title="Escolher como endereço de entrega"
		onClick={onClick}>
		<span className="bold">Informe o endereço completo</span> <br />
		{city} - {state}
	</div>
)

export default Address
